import { Fragment, useCallback, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import FormProvince, { ProvinceForm } from 'system/geographic/components/province/form';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonProvinceCrumbs } from '../constants';
import { HttpResponse } from 'shell/models/http-response';
import { Province } from 'shell/models/province';
import { toast } from 'react-toastify';

const ProvinceEditPage = (): React.ReactElement => {
  const { put: updateProvince } = useHttpFetch(`${__MUNICIPALITY_API_URL__}/geo/provincia`);

  const params = useParams();

  const {
    get: getProvince,
    data,
    error,
    loading,
  } = useHttpFetch<HttpResponse<Province>>(
    `${__MUNICIPALITY_API_URL__}/geo/provincia/${params.id}`
  );

  useEffect(() => {
    getProvince();
  }, []);

  const province: ProvinceForm = useMemo(() => {
    const provincePayload = data?.payload;
    if (!provincePayload || !!error) {
      return {};
    }
    return {
      code: provincePayload.key.codice,
      name: provincePayload.nome,
      region: provincePayload.codRegione,
    };
  }, [data, error]);

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: ProvinceForm | undefined) => {
      updateProvince(`/${formValues?.code}`, {
        codRegione: formValues?.region,
        regione: {
          key: {
            codice: formValues?.region,
          },
        },
        nome: formValues?.name,
        key: {
          codice: formValues?.code,
        },
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/geografiche/italia/provincia');
      });
    },
    [updateProvince, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonProvinceCrumbs, { name: 'Modifica Provincia' }]} />
      {loading || error || !data ? undefined : (
        <FormProvince
          title="Modifica Provincia"
          onOk={onSubmit}
          initialValues={province}
          isEdit
          onCancel={() => {
            navigate('/sistema/geografiche/italia/provincia');
          }}
        />
      )}
    </Fragment>
  );
};

ProvinceEditPage.displayName = 'Province edit page component';

export default ProvinceEditPage;
